export default __webpack_public_path__ + "static/media/Grafiki_ili.1ff471e1.jpg";